import { Injectable, Pipe, PipeTransform } from "@angular/core";
import { SettingResult, SettingsService } from "../core/settings/settings.service";

@Pipe({
  name: "settingValue"
})
@Injectable({
  providedIn: 'root'
})
export class SettingValuePipe implements PipeTransform {
  constructor(private settingsService: SettingsService) {
  }

  transform(setting: SettingResult): string {
    const settingValue = this.getDisplayedSettingValue(setting.name, setting.value);

    if (setting.isPending) {
        // devices without a last known value have not completed an initial sync with the backend
        if (setting.lastKnownValue === undefined) {
            return `${settingValue} (value is pending, current value: undefined, awaiting initial settings sync)`;
        }

        const lastKnownValue = this.getDisplayedSettingValue(setting.name, setting.lastKnownValue);

      return `${settingValue} (value is pending, current value: ${lastKnownValue})`;
    }

    return settingValue;
  }

  getDisplayedSettingValue(settingName: string, settingValue: string): string {
    const settingType = this.settingsService.getSettingType(settingName);

    let displayedSettingValue = settingValue;
    if (settingType.allowableValues.length) {
      const matchingAllowableValue = settingType.allowableValues.find(av => av.value === settingValue);

      if (matchingAllowableValue) {
        displayedSettingValue = matchingAllowableValue.label;
      }
    }

    if (settingType.units) {
      displayedSettingValue = `${displayedSettingValue} ${settingType.units}`;
    }

    return displayedSettingValue;
  }
}
